import { Result } from "../../model";
import axios from "axios";
import qs from "qs";
import config from "../config";
import Cookies from "js-cookie";
import Vue from "vue";
// import contents from "../../../store/content";

axios.defaults.withCredentials = true;

export default {
  /**
   * get 请求
   * @param {string} url
   * @param params
   * @returns {Promise<>}
   */
  async get(url, params) {
    let result = null;
    //相对路径
    let hostUrl = document.location.host;
    let getapi = config.host;
    let allUrl = "";
    if (getapi === "/api") {
      allUrl = getapi;
    } else {
      allUrl = "//" + hostUrl + getapi.replace("upapi", "api");
    }

    try {
      let response = await axios.get(allUrl + url, {
        params: params,
        // headers: {
        //   Authorization: this._getToken()
        // }
      });
      result = response.data;
      if (result.errorCode === 200600) {
        Vue.prototype.$notify({
          message: result.errorMess,
        });
      } else if (result.errorCode === 200150) {
        Vue.prototype.$notify({
          message: result.errorMess,
        });
      }
    } catch (e) {
      result = await new Result(500, e, "服务器错误");
    }
    return result;
  },

  /**
   * post 请求
   * @param {string} url
   * @param body
   * @param params
   * @returns {Promise<>}
   */
  async post(url, body, params) {
    let result = null;

    //相对路径
    let hostUrl = document.location.host;
    let getapi = config.host;
    let allUrl = "";
    if (getapi === "/api") {
      allUrl = getapi;
    } else {
      allUrl = "//" + hostUrl + getapi.replace("upapi", "api");
    }
    try {
      let response = await axios.post(
        allUrl + url,
        qs.stringify(body, {
          arrayFormat: "repeat",
        }),
        {
          params: params,
          // headers: {
          //   Authorization: this._getToken()
          // }
        }
      );
      result = response.data;

      // if (result.errorCode === 200600) {
      //   contents.state.showLoginDialogs = true;
      //   contents.state.showMessage =
      //     "您当前试用次数已用完，请登录账号享更多权限";
      // } else if (result.errorCode === 300000) {
      //   contents.state.showLoginDialogs = true;
      //   contents.state.showMessage = "您当账号暂未登录，请登录账号享更多权限";
      // } else if (result.errorCode > 0) {
      //   console.log(url);
      //   if (url.indexOf("ParagraphProgress") === -1) {
      //     Vue.prototype.$message({
      //       showClose: true,
      //       message: result.errorMess,
      //       type: "error"
      //     });
      //   }
      // }
    } catch (e) {
      if (e && e.response && e.response.data.errorCode === 401) {
        window.$vue.$router.replace("/login");
      }

      result = await new Result(500, e, "服务器错误");
    }
    return result;
  },
  formatTime(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    var day = date.getDate();
    day = day < 10 ? "0" + day : day;
    return year + "-" + month + "-" + day;
  },
  _getToken() {
    //return "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUyODIzNSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3NpZCI6IjUyODIzNSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvZXhwaXJhdGlvbiI6IjMvMy8yMDIwIDk6MDU6MzMgQU0iLCJuYmYiOjE1ODEwNjYzMzMsImV4cCI6MTU4MzIyNjMzMywiaWF0IjoxNTgxMDY2MzMzLCJpc3MiOiJ3d3cuNTExOC5jb20iLCJhdWQiOiJ3d3cuNTExOC5jb20ifQ.-Z839y2T-qUzZswhY8oHIbF3WsopKC6K6N3utq6NwG0";

    let user = Cookies.get("user");
    var data = this.formatTime(new Date());
    var loginLink =
      process.env.NODE_ENV === "development"
        ? "http://d-account.5118.com/account/RefreshToken"
        : "https://ciyun.5118.com/api/account/RefreshToken";
    // loginLink = "http://localhost:8081/api/account/RefreshToken";

    if (user && JSON.parse(user).userInfo.tokenEndTime) {
      let tokenEndTime = JSON.parse(user).userInfo.tokenEndTime;
      if (data > tokenEndTime) {
        //已过期
        fetch(loginLink, {
          headers: {
            Authorization: JSON.parse(user).token,
          },
        })
          .then((res) => res.text())
          .then(function(res) {
            //删除cookie
            // Cookies.remove("user");
            //重新设置cookie
            var exp = new Date();
            exp.setTime(exp.getTime() + 99999 * 24 * 60 * 60 * 1000);
            Cookies.set("user", JSON.stringify(res.data), { expires: exp });
            let user = JSON.parse(res.data);
            this.MSet(user.userInfo);
          });
      }
    }

    if (user) {
      return JSON.parse(user).token;
    }
    return "";
  },
};
